import styles from './ScenarioMajorButton.module.css';
import { editItemIcon, eyeIcon } from '../../assets/icons';

interface ScenarioButtonProps {
  onClick: () => void;
}

export const ScenarioStartButton = ({ onClick }: ScenarioButtonProps) => (
  <button 
    className={`${styles.button} ${styles.start}`} 
    onClick={onClick}
  >
    <span className={styles.startIcon}>▶</span>
    START
  </button>
);

export const ScenarioEditButton = ({ onClick }: ScenarioButtonProps) => (
  <button 
    className={`${styles.button} ${styles.edit}`} 
    onClick={onClick}
  >
    <img src={editItemIcon} alt="Edit" className={styles.buttonIcon} />
    EDIT
  </button>
);

export const ScenarioViewButton = ({ onClick }: ScenarioButtonProps) => (
  <button 
    className={`${styles.button} ${styles.view}`} 
    onClick={onClick}
  >
    <img src={eyeIcon} alt="View" className={styles.buttonIcon} />
    VIEW
  </button>
); 